export const parseDate = (date) => {
    if (!date)
        return new Date();
    if (date instanceof Date) {
        return date;
    }
    else {
        return new Date(date.replace(/-/g, '/'));
    }
};
export const formatDateYYYYMMDD = (date) => {
    return date.toISOString().slice(0, 10); // YYYY-MM-DD
};
export const THMoment = {
    getDateXDaysFrom(date, days) {
        const DAYS_IN_MS = days * 24 * 60 * 60 * 1000;
        return new Date(date.getTime() - DAYS_IN_MS);
    },
    getZeroDate(date) {
        const _date = date instanceof Date ? date : new Date(date);
        return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
    }
};
//# sourceMappingURL=parseDate.js.map